import { render, staticRenderFns } from "./print-data.vue?vue&type=template&id=4658dbda&lang=pug&"
import script from "./print-data.vue?vue&type=script&lang=js&"
export * from "./print-data.vue?vue&type=script&lang=js&"
import style0 from "./print-data.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4658dbda')) {
      api.createRecord('4658dbda', component.options)
    } else {
      api.reload('4658dbda', component.options)
    }
    module.hot.accept("./print-data.vue?vue&type=template&id=4658dbda&lang=pug&", function () {
      api.rerender('4658dbda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/print-data.vue"
export default component.exports